import dayjs from "dayjs";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const setWithExpiry = (key, value, ttl) => {
	const now = dayjs(new Date());

	const item = {
		value: value,
		expiry: now.add(ttl, "minute"),
	};

	AsyncStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = async (key) => {
	const itemStr = await AsyncStorage.getItem(key);
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = dayjs(new Date());

	// compare the expiry time of the item with the current time
	if (now > dayjs(item.expiry)) {
		// If the item is expired, delete the item from storage
		// and return null
		AsyncStorage.removeItem(key);
		return null;
	}
	return item.value;
};
